export default __webpack_public_path__ + "static/media/google.31f47e8e.svg";